import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IProjectNote } from '../interfaces/IProjectNote';

@Injectable({
    providedIn: 'root'
})
export class MemberNoteService {
    constructor(private http: HttpClient) { }

    create(projectID: number, noteText: string): Observable<IProjectNote> {
        return this.http.post<IProjectNote>('/api/memberNote', { projectID, noteText });
    }

    update(noteID: number, memberNote: IProjectNote): Observable<IProjectNote> {
        return this.http.put<IProjectNote>(`/api/memberNote/${noteID}`, { memberNote });
    }

    delete(noteID: number): Observable<void> {
        return this.http.delete<void>(`/api/memberNote/${noteID}`);
    }
}
